module.exports = __webpack_public_path__ + "img/PL08736.d9d49a63.png";